import { gql } from '@apollo/client';

/**
 * Listar facturas locales con filtros y paginación
 */
export const LISTAR_FACTURAS = gql`
  query ListarFacturas(
    $fecha_inicio: Date
    $fecha_fin: Date
    $busqueda: String
    $limit: Int
    $offset: Int
  ) {
    listarFacturas(
      fecha_inicio: $fecha_inicio
      fecha_fin: $fecha_fin
      busqueda: $busqueda
      limit: $limit
      offset: $offset
    ) {
      facturas {
        id
        numero_factura
        prefijo
        numero_display
        fecha
        subtotal
        iva
        descuento
        total
        estado
        tipo_factura
        cliente_nombre
        cliente_documento
        created_at
      }
      total
    }
  }
`;

/**
 * Obtener factura completa con detalles para PDF
 */
export const OBTENER_FACTURA_COMPLETA = gql`
  query ObtenerFacturaCompleta($factura_id: Int!) {
    obtenerFacturaCompleta(factura_id: $factura_id) {
      id
      numero_factura
      prefijo
      numero_display
      fecha
      subtotal
      iva
      descuento
      propina
      total
      estado
      tipo_factura
      observaciones
      cliente {
        nombre
        tipo_documento
        numero_documento
        direccion
        telefono
        email
      }
      detalles
      metodos_pago
      emisor {
        nombre
        nit
        direccion
        ciudad
        departamento
        telefono
        email
        logo_url
        eslogan
      }
      resolucion {
        numero
        prefijo
        rango_inicio
        rango_fin
        fecha_inicio
        fecha_fin
      }
    }
  }
`;
